module.exports = __webpack_public_path__ + "img/MDI-motion-play.6d332c7d.svg";